import React from 'react';
import { useHistory } from 'react-router-dom';
import { modalStore } from 'components/layout/modals/ModalStore';

export default function ExternalApplicationSuccess() {
	const history = useHistory();

	const close = () => {
		modalStore.closeDialog();
	};

	const viewOtherOpportunities = () => {
		modalStore.closeDialog();
		history.push('/jobs');
	};

	return (
		<div className="ExternalApplicationModal ExternalApplicationSuccess">
			<div className="external-application-modal-top">
				<button
					type="button"
					className="external-application-modal-close"
					onClick={close}
					aria-label="Close">
					<img src="/ats/icons/close-3-icon.svg" alt="" />
				</button>
			</div>
			<div className="external-application-success-body">
				<div className="external-application-success-icon">
					<img src="/ats/icons/external-application-success-chair.svg" alt="" />
				</div>
				<h2>Thank you for applying!</h2>
				<p>
					We’ve received your information
					<br />
					and will review your application shortly.
				</p>
			</div>
			<div className="external-application-modal-footer">
				<button
					type="button"
					className="external-application-btn is-secondary"
					onClick={close}>
					Close
				</button>
				<button
					type="button"
					className="external-application-btn is-primary"
					onClick={viewOtherOpportunities}>
					View Other Opportunities
				</button>
			</div>
		</div>
	);
}
